import React from "react"
import PropTypes from "prop-types"
import dayjs from "dayjs"
import LocalizedFormat from "dayjs/plugin/localizedFormat"

dayjs.extend(LocalizedFormat)

const DateTime = ({ date }) => (
  <div>
    <div>
      {dayjs
        .utc(date)
        .local()
        .format("YYYY-MM-DD LT")}
    </div>
    <div>
      <span className='muted small'>(UTC: {dayjs.utc(date).format("LT")})</span>
    </div>
  </div>
)

DateTime.propTypes = {
  date: PropTypes.string
}

export default DateTime
